import { Component, OnInit, Input } from '@angular/core';
import { IMedicationStatement, IPatient } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddComponent } from '../../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { ModalController } from '@ionic/angular';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'inc-medication-add',
  templateUrl: './medication-add.component.html',
  styleUrls: ['./medication-add.component.scss'],
})
export class MedicationAddComponent extends AbstractAddComponent<IMedicationStatement> implements OnInit {
  @Input() patient: IPatient;
  @Input() isModal: boolean;

  constructor(private modalController: ModalController) {
    super();
  }

  ngOnInit() {
    this.form.controls.subject.setValue({ display: this.patient.name[0].text, reference: this.patient.id });
    if (this.inData) {
      this.form.patchValue(this.inData);
    }
  }

  close(data?: IMedicationStatement) {
    if (this.isModal) {
      data ? this.modalController.dismiss(data) : this.modalController.dismiss();
    } else {
      this.save(data);
    }
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      dateAsserted: new FormControl(new Date().toISOString()),
      status: new FormControl('intended'),
      category: new FormControl('community'),
      medicationReference: new FormGroup({
        display: new FormControl('')
      }),
      subject: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      dosage: new FormArray([new FormGroup({
        text: new FormControl()
      })]),
      reasonCode: new FormArray([
        new FormGroup({
          coding: new FormArray([
            new FormGroup({
              code: new FormControl(''),
              display: new FormControl(''),
              system: new FormControl('')
            })
          ]),
          text: new FormControl()
        })
      ])
    });
  }

}
